<template>
  <v-menu
    v-show="!disabled"
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-show="!disabled"
        v-model="date"
        :label="label"
        :hint="hint"
        :rules="rules"
        :hide-details="hideDetails"
        append-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        clearable
        outlined
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :rules="rules"
      :allowed-dates="allowedDates"
      no-title
      scrollable
      @input="updateValue"
    >
      <template v-if="hasConfirmBtn">
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="updateValue"
        >
          OK
        </v-btn>
      </template>
    </v-date-picker>
  </v-menu>
</template>
<script>
import moment from '@/utils/moment'

export default {
  props: {
    typeConfig: {
      type: Object,
      default() {
        return {
          hasConfirmBtn: false,
          dateFormat: null,
          timeFormat: null,
          dateTimeFormat: null,
        }
      },
    },
    value: {},
    label: {},
    hint: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    defaultDateFormat: 'yyyy-MM-DD',
    date: null,
    menu: false,
    defaultDisabled: false,
  }),
  computed: {
    // disabled() {
    //   return this.typeConfig.disabled || this.defaultDisabled
    // },
    allowedDates() {
      return this.typeConfig.allowedDates || null
    },
    rules() {
      return this.typeConfig.rules || []
    },
    hasConfirmBtn() {
      return this.typeConfig.hasConfirmBtn || false
    },
    dateFormat() {
      return this.typeConfig.dateFormat || this.defaultDateFormat
    },
    timeFormat() {
      return this.typeConfig.timeFormat || this.defaultTimeFormat
    },
    datetimeFormat() {
      return this.typeConfig.dateTimeFormat || this.defaultDateTimeFormat
    },
    dateValue() {
      return this.toDate(this.value1)
    },
    timeValue() {
      return this.toTime(this.value2)
    },
    hideDetails() {
      if (this.typeConfig.hideDetails) {
        return this.typeConfig.hideDetails
      }

      return 'auto'
    },
  },
  watch: {
    value(newvalue) {
      console.log('Date Picker watch value', newvalue)
      if (newvalue) {
        this.date = this.toDate(new Date(newvalue))
      } else {
        this.date = null
      }

      // this.updateValue(newvalue)
    },
    typeConfig(newvalue) {
      console.log('Date Picker watch typeConfig', newvalue)
    },
  },

  // mounted() {
  //   this.date = this.toDate(new Date())
  //   this.updateValue(this.date)
  // },
  methods: {
    updateValue(newvalue) {
      console.log('Date Picker updateValue', newvalue)

      // this.date = this.toDate(newvalue)
      if (this.$refs.menu) {
        this.$refs.menu.save(this.date)
      }
      this.$emit('input', this.date)

      // console.log('emit', this.date)
    },
    toDate(date) {
      return moment(date).format(this.dateFormat)
    },
  },
}
</script>
